import { AfterViewInit, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FairConfiguration } from '@planone/bau365/data-access-fair-data';
import { EnrichedWatchlistItem, WatchlistItemIdentity } from '@planone/bau365/data-access-user';
import { EntityType } from '@planone/bau365/util-fair-data';
import { DataAccessTogglesFacade } from '@planone/shared/data-access-feature-flags';
import { ModalBottomsheetHelper, ModalBottomsheetType, ShareButtonsHelper } from '@planone/shared/ui-elements';

import { map, Observable } from 'rxjs';

import { ItemType } from '../../page-watchlist/page-watchlist.model';

@Component({
  selector: 'bau365-watchlist-item',
  templateUrl: './watchlist-item.component.html',
  styleUrls: ['./watchlist-item.component.scss'],
})
export class WatchlistItemComponent implements AfterViewInit {
  @ViewChild('shareButtonsTitle') public shareButtonsTitle: TemplateRef<never> | null | undefined;
  @ViewChild('shareButtons') public shareButtons: TemplateRef<never> | null | undefined;

  @Input() item?: EnrichedWatchlistItem;
  @Input() fair?: FairConfiguration;
  @Input() itemType?: ItemType;
  @Input() screen?: string | null;

  @Output() deleteItem = new EventEmitter<WatchlistItemIdentity>();
  @Output() shareItem = new EventEmitter<WatchlistItemIdentity>();
  @Output() shareItemAction = new EventEmitter<{ network: string; item?: WatchlistItemIdentity }>();

  hallPlanToggle$: Observable<boolean | undefined>;
  companyLabel: string = $localize`:@@featureWatchlist-type-indicator-company:Unternehmen`;

  EntityType = EntityType;

  public url?: string;

  constructor(
    private readonly modalBottomsheetHelper: ModalBottomsheetHelper,
    private readonly shareButtonsHelper: ShareButtonsHelper,
    public togglesFacade: DataAccessTogglesFacade
  ) {
    this.hallPlanToggle$ = togglesFacade.flag('kill-hall-plan').pipe(map((hallplanDisabled) => !hallplanDisabled));
  }

  ngAfterViewInit() {
    if (!this.itemType || !this.item) return;
    const baseUrl = `fairs/${this.item.fair_id}/${this.itemType.slug}/`;
    this.url = this.shareButtonsHelper.buildShareUrlFromPath(baseUrl + encodeURIComponent(this.item.entity_id));
  }

  openShareDialog(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.modalBottomsheetHelper.openDialog(
      ModalBottomsheetType.share,
      this.shareButtonsTitle,
      this.shareButtons,
      this.screen ?? 'desktop'
    );

    this.shareItem.emit(this.item);
  }

  deleteWatchlistItem(item: WatchlistItemIdentity) {
    this.deleteItem.emit(item);
  }

  shareButtonClick(network: string) {
    this.shareItemAction.emit({
      network: network,
      item: this.item,
    });
  }
}
